import React from "react";


interface TestimonialCardProps {
  message: string;
  name: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ message, name }) => {
  return (
    <div className="relative bg-white/30 backdrop-blur-lg border border-white/20 rounded-2xl p-6 md:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
    {/* Subtle Glow Accent */}
    <div className="absolute -top-5 -right-5 w-20 h-20 bg-blue-400/20 blur-2xl rounded-full z-0"></div>
  
    <div className="relative z-10">
      <p className="text-gray-800 text-md md:text-lg italic leading-relaxed mb-4">
        “{message}”
      </p>
      <h4 className="text-blue-700 font-semibold text-sm tracking-wide uppercase">
        — {name}
      </h4>
    </div>
  </div>
  
  );
};

export default TestimonialCard;